import clsx from "clsx";
import CountryList from "components/moleculs/CountryList";
import { Link } from "react-router-dom";
import { countryList } from "data/countryList";
import { TextBadge, SectionTitle, Subtitle } from "components/atoms/Text";

const Locations = ({ classNames }) => {
    return (
        <section className={clsx(
            "features w-full max-w-[1440px] mx-auto desktop:pt-[80px] desktop:pb-[112px] py-[96px] tablet:py-16 phone:py-12",
            classNames
        )}>
            <section className={clsx(
                "w-full bg-neutral-10",
                "px-6 tablet:px-8 desktop:px-[120px]",
                "flex flex-col md:flex-row items-center justify-between"
            )}>
                <div className="w-full max-w-[491px] tablet:max-w-[386px]">
                    <TextBadge>Locations</TextBadge>
                    <SectionTitle classNames="tablet:!text-heading-3 tablet:!leading-[54px]">Worldwide Services</SectionTitle>
                    <Subtitle classNames="phone:!text-[16px]">We do our best to offer proxies and SOCKS 5 from as many locations as possible. If you need a location added don't hesitate to contact us via our support channels and we will do our best to accomodate your request.</Subtitle>
                    <a href="/support/contact">
                        <button className="phone:w-full phone:py-[18px] w-fit py-[18px] px-[42.5px] rounded-lg text-md text-neutral-10 font-semibold text-basier-circle-semibold phone:mt-6 leading-[19.83px] tablet:mt-8 mt-10 bg-primary-main hover:bg-primary-hover">Contact Us</button>
                    </a>
                </div>
                {/* Country Provide Proxy */}
                <div className="w-full phone:mt-12 justify-between mt-10 md:mt-0 tablet:max-w-[508px] max-w-[640px] grid-cols-2 grid md:grid-cols-3 tablet:gap-y-14 tablet:gap-x-4 desktop:gap-x-12 phone:gap-y-8 gap-y-16">
                    {countryList.map((item) => (
                        <CountryList key={item.id} country={item.country} countryFlag={item.flag} />
                    ))}
                </div>
            </section>
        </section>
    );
};

export default Locations;